import { render, staticRenderFns } from "./lawsuit-follow-execute.vue?vue&type=template&id=5bbf6484&scoped=true"
import script from "./lawsuit-follow-execute.vue?vue&type=script&lang=ts"
export * from "./lawsuit-follow-execute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf6484",
  null
  
)

export default component.exports